// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Service imports
import { MPCacheRegistrationService } from '../../../../_services/shared-services/mp-cache-registration-service';

// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';
import { CacheDuration } from '../../../../_constants/cache-duration';

// Model imports
import { JournalEntryDetailParameterDto } from '../../_models/general-ledger/journal-entry/journal-entry-detail-parameter-dto';
import { JournalEntryDetailsResultDto } from '../../_models/general-ledger/journal-entry/journal-entry-details-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import { JournalEntryAttachmentUpdateParametersDto } from '../../_models/general-ledger/journal-entry/journal-entry-attachment-update-parameters-dto';
import { JournalEntryAttachmentParameterDto } from '../../_models/general-ledger/journal-entry/journal-entry-attachment-parameter-dto';

@Injectable({
    providedIn: 'root'
})
export class JournalEntryDetailService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getJournalEntryDetails(param: JournalEntryDetailParameterDto): Observable<JournalEntryDetailsResultDto> {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/detail${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get<JournalEntryDetailsResultDto>(url, options)
            .pipe(
                map((response: JournalEntryDetailsResultDto) => plainToClass(JournalEntryDetailsResultDto, response))
            );
    }

    getJournalEntryDetailHistory(param: JournalEntryDetailParameterDto): Observable<TransactionLogResultDto[]> {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/history${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get<TransactionLogResultDto[]>(url, options)
            .pipe(map((response: TransactionLogResultDto[]) => plainToClass(TransactionLogResultDto, response)));
    }

    getJEAttachmentfile(param: JournalEntryAttachmentParameterDto): Observable<Blob> {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/attachment${param.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((responseData: any) => new Blob([responseData])));
    }

    updateJEAttachments(params: JournalEntryAttachmentUpdateParametersDto): Observable<any> {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/attachment`;
        return this.httpClient.post(url, classToPlain(params)).pipe(map((response: any) => response));
    }
}
